<div
  scId="SC1555"
  *ngIf="aemConfigurableData && hardGoods && hardGoods?.length > 0; else displayNoResultsFound"
  attr.pdlPageComponentId="{{ pdlPageComponentId }}"
  attr.pdlRepeatedComponent="{{ pdlRepeatedComponent }}"
>
  <div *ngFor="let category of hardGoods">
    <!-- TODO: Total number will be retrieved from Api_2166 once it is deployed.  -->
    <h2 class="m-t-xl m-l-sm inline-block">{{ category?.categoryName }}</h2>
    <div
      class="inline-block m-l-sm"
      *ngIf="category?.products?.length >= 3 && category?.categoryCount >= 3; else elseBlock"
    >
      <p>
        <span> ({{ accessoryCount }} of {{ category?.categoryCount }})</span>
      </p>
    </div>

    <ng-template #elseBlock>
      <p class="inline-block m-l-sm">
        <span> ({{ category?.products?.length }} of {{ category?.products?.length }})</span>
      </p>
    </ng-template>
    <div *ngFor="let hardgood of category?.products; let idx = index">
      <div *ngIf="idx % 3 == 0 && idx < 3" class="row m-t-xl">
        <div
          *ngFor="let hardgood of category?.products | loopUnroll: idx : 3; let i = index"
          class="col-12 col-md-4 text-center"
          id="product-{{ hardgood?.offerId }}"
        >
          <tmo-browse-hardgood
            *ngIf="hardgood"
            [isSearchedProduct]="false"
            [hardgoodData]="hardgood"
            [disableCheckbox]="disableCheckbox"
            [isLineInFocus]="isLineInFocus"
            [contentData]="aemConfigurableData"
            (onCheck)="onCheckboxClick($event)"
          >
          </tmo-browse-hardgood>
        </div>
      </div>
    </div>
    <div class="row">
      <div *ngIf="category?.products?.length === 0" class="col-12">
        <p>{{ aemConfigurableData?.problemRetrievingAccessories }}</p>
      </div>
      <div class="col-12 button-spacing">
        <div class="button-box">
          <button
            class="btn btn-primary"
            attr.aria-label="{{ aemConfigurableData?.seeAll }}"
            [disabled]="category?.products?.length > 0 && category?.products?.length < 3"
            (click)="navigateToCdp(category.categoryName)"
            id="see-all-{{ category.products[0]?.productSubType }}"
          >
            {{ aemConfigurableData?.seeAll }}
          </button>
        </div>
      </div>
      <div class="col-12">
        <hr class="divider" />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 m-t-lg">
      <a
        href="javascript:void(0)"
        attr.aria-label="{{ aemConfigurableData?.seeMore }}"
        [hidden]="!showSeeMore"
        (click)="onScroll()"
        class="hover-magenta"
        id="cta-default-132"
        >{{ aemConfigurableData?.seeMore }}</a
      >
    </div>
  </div>
  <div class="row">
    <div *ngIf="showComponentSpinner" class="col-6">
      <tmo-inline-spinner
        class="pull-right"
        [setDelay]="!showComponentSpinner"
      ></tmo-inline-spinner>
    </div>
  </div>
</div>
<ng-template #displayNoResultsFound>
  {{ aemConfigurableData?.noResultsFound }}
</ng-template>
